/* eslint-disable react/prop-types */
import React from "react";

const Pagination = ({ currentPage, totalPage, clickPage }) => {
  if (totalPage <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const showAround = 2; // How many pages to show around current

    if (totalPage <= 7) {
      for (let i = 1; i <= totalPage; i++) pages.push(i);
    } else {
      // Always show first page
      pages.push(1);

      if (currentPage > showAround + 2) {
        pages.push("...");
      }

      const start = Math.max(2, currentPage - showAround);
      const end = Math.min(totalPage - 1, currentPage + showAround);

      // Adjust start/end if near boundaries to keep a consistent number of buttons
      let adjustedStart = start;
      let adjustedEnd = end;
      
      if (currentPage <= showAround + 2) {
        adjustedEnd = 1 + showAround * 2 + 1;
      } else if (currentPage >= totalPage - (showAround + 1)) {
        adjustedStart = totalPage - (showAround * 2 + 1);
      }

      for (let i = Math.max(2, adjustedStart); i <= Math.min(totalPage - 1, adjustedEnd); i++) {
        pages.push(i);
      }

      if (currentPage < totalPage - (showAround + 1)) {
        pages.push("...");
      }

      // Always show last page
      pages.push(totalPage);
    }
    return pages;
  };

  return (
    <div className="flex justify-end mt-10 mr-10 mb-20">
      <div className="join border border-[#91949D] bg-white rounded-lg overflow-hidden shadow-sm">
        <button
          className="join-item btn btn-md bg-white border-none text-[#91949D] hover:bg-gray-100 disabled:bg-gray-50 flex items-center justify-center min-w-[3rem]"
          disabled={currentPage === 1}
          onClick={() => clickPage(currentPage - 1)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        
        {getPageNumbers().map((page, index) => (
          <button
            key={index}
            className={`join-item btn btn-md border-none min-w-[3rem] ${
              page === currentPage
                ? "bg-[#1E82BE] text-white hover:bg-[#156a9c]"
                : "bg-white text-[#696969] hover:bg-gray-100"
            } ${page === "..." ? "btn-disabled bg-white pointer-events-none" : ""}`}
            onClick={() => page !== "..." && clickPage(page)}
          >
            {page}
          </button>
        ))}

        <button
          className="join-item btn btn-md bg-white border-none text-[#91949D] hover:bg-gray-100 disabled:bg-gray-50 flex items-center justify-center min-w-[3rem]"
          disabled={currentPage === totalPage}
          onClick={() => clickPage(currentPage + 1)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
